import {Component, HostListener, OnInit} from '@angular/core';
import {fadeAnimation} from './animations';
import {HOME} from './app.constants';
// import {CookiePolicyService} from './core/services/cookie-policy.service';

declare let gtag: any;

export interface Cookie { name: string; value: string; }

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    animations: [fadeAnimation]
})
export class AppComponent implements OnInit {

    public overlay = false;
    public domain = HOME;
    isMobile = false;
    public innerWidth: any;
    title = 'app-montreal';
    overlayMessage = 'Uma Mensagem Aqui';
    showOverlayMessage = false;
    remBreakpoints = {
        xs: 1,
        sm: 37.5,
        md: 45,
        lg: 52.5,
        xl: 79.5,
    };

    gridTheme = {
        breakpoints: {
            xs: this.remToPx(this.remBreakpoints.xs),
            sm: this.remToPx(this.remBreakpoints.sm),
            md: this.remToPx(this.remBreakpoints.md),
            lg: this.remToPx(this.remBreakpoints.lg),
            xl: this.remToPx(this.remBreakpoints.xl),
        }
    };
    remToPx(remp: number) {
        return remp * 16;
    }
    // constructor(private cookiePolicyService: CookiePolicyService) {}
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    public showOverlay(message = '') {
        setTimeout(() => {
            this.overlayMessage = message;
            this.showOverlayMessage = message !== '';
            this.overlay = true;
        });
    }

    public hideOverlay() {
        setTimeout(() => {
            this.overlay = false;
            this.showOverlayMessage = false;
        });
    }

    ngOnInit(): void {
        this.handleMobile();
    }

    private currentView(): string {
        const currentUrl =  window.location.href || '';

        return currentUrl.replace(`${this.domain}/`, '');
    }

    showHeader(): boolean {
        const homeParam = this.currentView()[0] === '?';
        if(homeParam) {
            return false;
        }

        switch (this.currentView()) {
            case 'comunidade':
                return false;
            case 'home':
                return false;
            case 'faca-parte-wilson':
                return false;
            case '':
                return false;
            default:
                return true;
        }
    }

    showNewHeader(): boolean {
        switch (this.currentView()) {
            case 'comunidade':
                return false;
            case 'nova-home':
                return true;
            default:
                return true;
        }
    }

    private handleMobile() {
        if (typeof window !== 'undefined') {
            this.innerWidth = window.innerWidth;
            if (this.innerWidth < this.gridTheme.breakpoints.lg) {
                this.isMobile = true;
                return;
            }
        }
        this.isMobile = false;
    }
}
